import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xl-12 col-xm-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "border p-2 p-lg-4 border-dark border-opacity-10" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4 col-sm-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-4 col-sm-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-4 col-sm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-6 col-sm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-4 col-sm-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = {
  key: 0,
  class: "col-md-4 col-sm-12"
}
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "col-md-4 col-sm-12" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "dropzone-container mb-3" }
const _hoisted_30 = {
  key: 0,
  class: "dropzone-content"
}
const _hoisted_31 = {
  key: 0,
  class: "files-list"
}
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "file-item" }
const _hoisted_34 = { class: "file-preview" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "file-icon"
}
const _hoisted_37 = { class: "file-info" }
const _hoisted_38 = { class: "file-name" }
const _hoisted_39 = { class: "file-size" }
const _hoisted_40 = { class: "file-actions" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "card-footer p-15 p-sm-20 p-md-25 p-lg-30 bg-white text-end" }
const _hoisted_43 = {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}
const _hoisted_44 = {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "redeForm",
          onSubmit: _ctx.soumettre,
          "validation-schema": _ctx.contratSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "card-title fw-bold mb-15 mb-lg-20 mb-xl-25" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        for: "reference",
                        class: "form-label fw-medium text-black"
                      }, " Référence ", -1)),
                      _createVNode(_component_Field, {
                        name: "reference",
                        modelValue: _ctx.reference,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reference) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "reference",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        for: "annee",
                        class: "form-label fw-medium text-black"
                      }, [
                        _createTextVNode(" Année "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "annee",
                        modelValue: _ctx.annee,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.annee) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.anneesOptions,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner une année" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "annee",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Date début "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "dateDebut",
                        type: "date",
                        modelValue: _ctx.dateDebut,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateDebut) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "dateDebut",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", {
                        for: "contrat",
                        class: "form-label fw-medium text-black"
                      }, [
                        _createTextVNode(" Contrat / Usager "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "contrat",
                        modelValue: _ctx.contrat,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contrat) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            "filter-results": false,
                            "min-chars": 2,
                            "resolve-on-load": false,
                            delay: 0,
                            searchable: true,
                            "options-limit": 300,
                            options: async (query) => {
                                                    if (query.length >= 3) {
                                                        const results = await _ctx.reupererContrat(query);
                                                        if (results && results.length > 0) {
                                                            return results;
                                                        } else {
                                                            return [
                                                                { value: '', label: 'Aucun enregistrement trouvé' },
                                                            ];
                                                        }
                                                    } else {
                                                        return [];
                                                    }
                                                },
                            noOptionsText: "Tapez au moins deux caractères",
                            placeholder: "Rechercher un contrat"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "contrat",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Agent "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "agent",
                        modelValue: _ctx.agent,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agent) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            options: _ctx.agentOptions,
                            searchable: true,
                            noResultText: "Aucun enregistrement trouvé",
                            placeholder: "Rechercher un percepteur"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "agent",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                        _createTextVNode(" Mois payé "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "periode",
                        modelValue: _ctx.periode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.periode) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.moisPayesOptions,
                            mode: "tags",
                            multiple: "true",
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner une période" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "periode",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                        _createTextVNode(" Mode de paiement "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "mode",
                        modelValue: _ctx.mode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mode) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.modes,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner un mode" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mode",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  (_ctx.showTransactionIdField)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                            _createTextVNode(" Référence externe "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "transactionId",
                            modelValue: _ctx.transactionId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.transactionId) = $event)),
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Entrer l'ID de transaction"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "transactionId",
                            class: "text-danger"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        for: "mois",
                        class: "form-label fw-medium text-black"
                      }, [
                        _createTextVNode(" Nombre de mois "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "mois",
                        modelValue: _ctx.mois,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mois) = $event)),
                        disabled: true,
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mois",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "montant",
                        class: "form-label fw-medium text-black"
                      }, " Montant ", -1)),
                      _createVNode(_component_Field, {
                        name: "montant",
                        modelValue: _ctx.montant,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.montant) = $event)),
                        disabled: true,
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "montant",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Fichiers justificatifs ", -1)),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          class: "dropzone-area",
                          onDrop: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
                          onDragover: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                          onDragenter: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                        }, [
                          (!_ctx.hasFiles)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[26] || (_cache[26] = [
                                _createElementVNode("i", { class: "flaticon-gallery-1 fs-1 text-muted" }, null, -1),
                                _createElementVNode("p", { class: "mt-2" }, "Glissez et déposez vos fichiers justificatifs ici", -1),
                                _createElementVNode("small", { class: "text-muted" }, "Formats acceptés: PDF, JPG, PNG (Max 10MB par fichier)", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 32),
                        _createElementVNode("input", {
                          ref: "fileInput",
                          type: "file",
                          multiple: "",
                          accept: ".pdf,.jpg,.jpeg,.png",
                          onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
                          style: {"display":"none"}
                        }, null, 544)
                      ]),
                      (_ctx.fichiersJustificatifs.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("h6", _hoisted_32, "Fichiers sélectionnés (" + _toDisplayString(_ctx.fichiersJustificatifs.length) + ")", 1),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.fichiersJustificatifs,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fichiersJustificatifs) = $event)),
                              "item-key": "id",
                              class: "files-grid",
                              onEnd: _ctx.onDragEnd
                            }, {
                              item: _withCtx(({ element, index }) => [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    (_ctx.isImage(element.file))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: element.preview,
                                          alt: "Preview",
                                          class: "file-thumbnail"
                                        }, null, 8, _hoisted_35))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[27] || (_cache[27] = [
                                          _createElementVNode("i", { class: "flaticon-file-1" }, null, -1)
                                        ]))]))
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("p", _hoisted_38, _toDisplayString(element.file.name), 1),
                                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.formatFileSize(element.file.size)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-outline-danger",
                                      onClick: ($event: any) => (_ctx.removeFile(index))
                                    }, [...(_cache[28] || (_cache[28] = [
                                      _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                    ]))], 8, _hoisted_41)
                                  ]),
                                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "drag-handle" }, [
                                    _createElementVNode("i", { class: "flaticon-menu" })
                                  ], -1))
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onEnd"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives(_createElementVNode("button", _hoisted_43, " Payer ", 512), [
                [_vShow, _ctx.valideEtape1]
              ]),
              _withDirectives(_createElementVNode("button", _hoisted_44, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))], 512), [
                [_vShow, !_ctx.valideEtape1]
              ]),
              _createVNode(_component_router_link, {
                to: "/liste-paiement",
                class: "btn btn-danger transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode("Annuler ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}